import type { StackProps } from '@mui/material';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import type { FC, SVGProps } from 'react';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

interface Props extends StackProps {
  title: string;
  total: number;
  percent: number;
  // price: number;
  color?: string;
  Icon: (props: SVGProps<SVGSVGElement>) => React.ReactNode;
}

export const ReceiptAnalytic: FC<Props> = ({
  title,
  total,
  color,
  percent,
  Icon,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      {...props}
      sx={[
        {
          alignItems: 'center',
          justifyContent: 'center',
          width: 1,
          minWidth: 200,

          padding: {
            xs: 2,
            lg: 0,
          },
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}
      >
        <Stack sx={{ fontSize: '24px', position: 'absolute' }}>
          <Icon />
        </Stack>

        <CircularProgress
          variant="determinate"
          value={percent}
          size={56}
          thickness={4}
          sx={{ color, opacity: 0.48 }}
        />

        <CircularProgress
          variant="determinate"
          value={100}
          size={56}
          thickness={4}
          sx={{
            color: 'grey.50016',
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: 0.48,
          }}
        />
      </Stack>
      <Stack spacing={0.5} sx={{ ml: 2 }}>
        <Typography variant="h6">{title}</Typography>

        <Typography variant="subtitle2">
          {total}{' '}
          <Box
            component="span"
            sx={{ color: 'text.secondary', typography: 'body2' }}
          >
            {t('common.receipts', { count: total })}
          </Box>
        </Typography>

        {/* <Typography variant="subtitle2" sx={{ color }}>
          {fCurrency(price)}
        </Typography> */}
      </Stack>
    </Stack>
  );
};
